// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : COMMENT LINES ADDED
// MODFIED DATA : 01-08-2025

/* eslint-disable import/no-anonymous-default-export */
import CenterActionTypes from './center.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// ADD DEALER RESPONSE
	addCenterDetailsResponse: null,
	// UPDATE DEALER RESPONSE
	updateCenterDetailsResponse: null,
	// GET DEALER LIST RESPONSE
	getCenterListResponse: null,
	getCenterListArr: [],
	// FETCH DEALER RESPONSE
	fetchCenterDetailsResponse: null,
	fetchCenterDetailsArr: [],
	// DELETE DEALER RESPONSE
	deleteCenterDetailsResponse: null,
	// FETCH CENTER UNIQUE ID RESPONSE
	fetchCenterUniqueIDResponse: null,
	fetchCenterUniqueIDArr: [],
	// EXPORT DEALER LIST RESPONSE
	exportCenterListResp: null,
	exportCenterListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD CENTER DETAILS START *********************** */
		case CenterActionTypes.ADD_CENTER_DETAILS_SUCCESS:
			return { ...state, addCenterDetailsResponse: action.payload };

		case CenterActionTypes.ADD_CENTER_DETAILS_FAILURE:
			return { ...state, addCenterDetailsResponse: action.payload };

		case CenterActionTypes.ADD_CENTER_DETAILS_RESPONSE_CHANGED:
			return { ...state, addCenterDetailsResponse: null };

		/** ***************** ADD CENTER DETAILS END *********************** */

		/** ***************** UPDATE CENTER DETAILS START *********************** */
		case CenterActionTypes.UPDATE_CENTER_DETAILS_SUCCESS:
			return { ...state, updateCenterDetailsResponse: action.payload };

		case CenterActionTypes.UPDATE_CENTER_DETAILS_FAILURE:
			return { ...state, updateCenterDetailsResponse: action.payload };

		case CenterActionTypes.UPDATE_CENTER_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateCenterDetailsResponse: null };
		/** ***************** UPDATE CENTER DETAILS END *********************** */

		/** ***************** GET CENTER DETAILS START *********************** */
		case CenterActionTypes.GET_CENTER_LIST_SUCCESS:
			return {
				...state,
				getCenterListResponse: action.payload,
				getCenterListArr: docodeHexResponse(action.payload, 'GetCenterListKey'),
			};

		case CenterActionTypes.GET_CENTER_LIST_FAILURE:
			return { ...state, getCenterListResponse: action.payload };

		case CenterActionTypes.GET_CENTER_LIST_RESPONSE_CHANGED:
			return { ...state, getCenterListResponse: null };
		/** ***************** GET CENTER DETAILS END *********************** */

		/** ***************** FETCH CENTER DETAILS START *********************** */
		case CenterActionTypes.FETCH_CENTER_DETAILS_SUCCESS:
			return {
				...state,
				fetchCenterDetailsResponse: action.payload,
				fetchCenterDetailsArr: docodeHexResponse(action.payload, 'FetchCenterDetailsKey'),
			};

		case CenterActionTypes.FETCH_CENTER_DETAILS_FAILURE:
			return { ...state, fetchCenterDetailsResponse: action.payload };

		case CenterActionTypes.FETCH_CENTER_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchCenterDetailsResponse: null, fetchCenterDetailsArr: [] };
		/** ***************** FETCH CENTER DETAILS END *********************** */

		/** ***************** DELETE CENTER DETAILS START *********************** */
		case CenterActionTypes.DELETE_CENTER_DETAILS_SUCCESS:
			return { ...state, deleteCenterDetailsResponse: action.payload };

		case CenterActionTypes.DELETE_CENTER_DETAILS_FAILURE:
			return { ...state, deleteCenterDetailsResponse: action.payload };

		case CenterActionTypes.DELETE_CENTER_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteCenterDetailsResponse: null };
		/** ***************** DELETE CENTER DETAILS END *********************** */
		default:
			return state;
	}
};
